/* eslint-disable import/no-anonymous-default-export */
import { MortageEdit } from './MortageEdit';
import { MortagesList } from './MortageList';

export default {
  list: MortagesList,
  edit: MortageEdit,
};
